import GlobalFooter from "@/src/components/GlobalElements/GlobalFooter";
import GlobalHeader from "@/src/components/GlobalElements/GlobalHeader";
import BaseLayout from "./BaseLayout";
import { Country } from "@/libs/geo/countries";
import { useGeoLoc } from "@/libs/geo/GeoLocProvider";
import { DarkThemeStyle } from "./DarkThemeStyle";

type NoGridLayoutProps = React.PropsWithChildren;

const NoGridLayout = ({ children }: NoGridLayoutProps) => {
  const { country } = useGeoLoc();

  return (
    <BaseLayout>
      <DarkThemeStyle />
      <div className="relative min-h-full flex-col flex bg-gray-950 w-full">
        <GlobalHeader position="absolute" />
        <div className="flex-grow flex w-full ">
          <div className="h-[inherit] w-full">{children}</div>
        </div>
        <GlobalFooter country={country as Country} />
      </div>
    </BaseLayout>
  );
};

export default NoGridLayout;
